export const isLoading = state => state.loading


// WEBPACK FOOTER //
// ./src/components/loader/loaderSelector.js